import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { getAssignedOrders } from '../Services/assignedOrdersApi';
import MapComponent from '../Components/ControlRoom/MapComponent';
import WhereSystem from '../WhereSystem';
import "../styles/schedule.css";

function haversineKm(a, b) {
  if (!a || !b || a.length < 2 || b.length < 2) return 0;
  const toRad = (deg) => (deg * Math.PI) / 180;
  const R = 6371; // km
  const [lat1, lon1] = a;
  const [lat2, lon2] = b;
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const s1 = Math.sin(dLat / 2);
  const s2 = Math.sin(dLon / 2);
  const aa = s1 * s1 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * s2 * s2;
  const c = 2 * Math.atan2(Math.sqrt(aa), Math.sqrt(1 - aa));
  return R * c;
}

export default function SchedulePage() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showAssigned, setShowAssigned] = useState(false);
  const [viewMode, setViewMode] = useState('grid');
  const [factories, setFactories] = useState([]);
  const [selectedFactory, setSelectedFactory] = useState(null);

  const navigate = useNavigate();
  const [expanded, setExpanded] = useState({});
  const [mapContainerSize,setMapContainerSize] = useState({height:"200px",width:"300px"})
  const mapContainerRef = useRef(null);   
  const loadAdminOrders = async () => {
    try {
      WhereSystem.services.orderService.getPendingOrders((res) => {
        console.log('admin pening orders in schedule page', res);
        const isOk = res?.IsSuccess === true || res?.isSuccess === true || Array.isArray(res);
        if (isOk) {
          const data = Array.isArray(res)
            ? res
            : (res?.ResultObject || res?.result || res?.data || []);

          setOrders(data);
          setLoading(false)
        } else {
          console.log('Failed to load admin orders', res?.message || res);
        }
      })

    } catch (e) {
      console.error('Error loading orders:', e);
    }
  };

  async function loadAssignedOrders() {
    setLoading(true);
    setError(null);
    try {
      getAssignedOrders((ordersData) => {
        setOrders(ordersData || []);
      });

    } catch (e) {
      setError('Failed to load assigned orders');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadAdminOrders();
   //setMapContainerSize({height:`${mapContainerRef.current.offsetHeight-10}px`, width:`${mapContainerRef.current.offsetWidth}px`});
  }, []);


  useEffect(() => {
    const load = async () => {
      try {
        WhereSystem.services.adminService.getFactories((res) => {
          console.log('factories in schedule page', res);
          const isOk = res?.IsSuccess === true || res?.isSuccess === true || Array.isArray(res);
          if (isOk) {
            const data = Array.isArray(res) ? res : (res?.ResultObject || res?.result || res?.data || []);
            setFactories((data || []).map(normalizeFactory));
          } else {
            console.log('Failed to load factories', res?.message || res);
          }
        })

      } catch (e) {
        console.error('Error loading factories:', e);
      }
    };

    load();
  }, []);

  const normalizeFactory = (f) => {
    if (!f) return null;
    // Support different shapes: {stationName}, {station_name}, {name}, {title}
    const stationName = f.stationName || f.station_name || f.name || f.title || f.station || "Unnamed Station";
    const id = f.id || f.stationId || f.station_id || stationName;
    return { ...f, stationName, id };
  };

  const handleChange = (e) => {
    //  const normalized = normalizeFactory(e.value);
    setSelectedFactory(e.target.value);
    console.log("Selected ID:", e.target.value?.id);
    console.log("Selected Name:", e.target.value?.stationName);
  };

  const onAssigningOrders =()=>{
    WhereSystem.services.adminService.SchedulingOrders((res) => {
      setShowAssigned(true)
      console.log('scheduling the orders', res);
      loadAssignedOrders();
    })
  }

  const count = orders?.length || 0;
  const headerTitle = showAssigned ? 'Scheduled Today Orders' : 'Orders List';

  return (
    <div className="cyber-page" style={{ minHeight: '92vh', paddingBottom: 20 }}>
      <div className="cyber-header" style={{ padding: '16px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, }}>
        <div>
          <h2 style={{ margin: 0, color: '#fff' }}>Today's Schedule</h2>
          <div style={{ marginTop: 4, color: 'var(--cy-muted)' }}> Manage deliveries across all Factories</div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Button label={showAssigned ? 'Scheduled Today Orders' : 'Schedule Orders'} icon="pi pi-calendar-plus" style={showAssigned ? { background: '#f59e0b', borderColor: '#f59e0b', color: '#001018' } : {}} severity={showAssigned ? undefined : 'success'}
            onClick={async () => {
              if (showAssigned) {
                setShowAssigned(false);
                await loadAdminOrders();
              } else {
                setShowAssigned(true);
                onAssigningOrders();
              }
            }}

          />


          {/* {showAssigned ? (
            <Button label="Scheduled Today Orders" icon="pi pi-calendar-plus" style={{ background: "#f59e0b", borderColor: "#f59e0b", color: "#001018" }}/>
          ) : (
            <Button label="Schedule Orders" icon="pi pi-calendar-plus" severity="success" onClick={onAssigningOrders}/>
          )} */}


          <Button label="Grid View" icon="pi pi-table" severity="success" outlined={viewMode !== 'grid'} onClick={() => setViewMode('grid')} />
          <Button label="Map View" icon="pi pi-map" severity={viewMode === 'map' ? 'info' : undefined} outlined={viewMode !== 'map'} onClick={() => setViewMode('map')} />
        </div>
      </div>

      {/* Main content */}
      <div style={{ padding: 20, display: 'grid', gap: 12 }}>
        <div className="schedule-toolbar">
          <div className="schedule-toolbar__left" style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'var(--cy-text)' }}>
            <i className="pi pi-box" style={{ color: 'var(--cy-accent)' }} />
            <strong style={{ fontSize: 18 }}>{headerTitle} ({count})</strong>
          </div>

          {!loading && !error && viewMode === 'map' &&
            <div className="schedule-toolbar__right mx-5" style={{ zIndex: "30000" }}>
              <span>Select Factory:</span>
              <select onChange={handleChange} class="form-select" aria-label="Factory dropdown">
                {
                  factories.map((factory, index) => {
                    return <option key={index} >{factory.stationName}</option>
                  })
                }
              </select>
            </div>
          }
        </div>
        {loading && (
          <Card className="cyber-card">
            <div style={{ padding: 12, color: 'var(--cy-muted)' }}>Loading...</div>
          </Card>
        )}

        {error && !loading && (
          <Card className="cyber-card">
            <div style={{ padding: 12, color: '#f87171' }}>{error}</div>
          </Card>
        )}

        {!loading && !error && viewMode === 'map' && (
          <div ref={mapContainerRef}>
            <MapComponent style={{height:"68vh",width:"98vw",zIndex:10000}}/>
          </div>
        )}

        {/* Grid View - Admin Orders */}
        {!loading && !error && viewMode === 'grid' && !showAssigned && (
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
            {orders.map((o) => {
              const km = haversineKm(o.pickupLocation, o.deliveryLocation);
              return (
                <Card key={o.orderId} className="cyber-card" style={{ overflow: "hidden", width: "100%", }}>
                  <div style={{ display: 'grid', gridTemplateColumns: '1.2fr 1fr 0.8fr', alignItems: 'center' }}>
                    {/* Order number + factory */}
                    <div style={{ minWidth: 0 }}>
                      <div style={{ fontWeight: 700, color: '#fff' }}>Order </div>
                      <div style={{ fontWeight: 700, color: '#fff' }}>{o.orderNo}</div>
                    </div>

                    {/* Customer + distance */}
                    <div style={{ minWidth: 0 }}>
                      <div style={{ fontWeight: 600, color: '#fff' }}>{o.customerName}</div>
                      <div style={{ color: 'var(--cy-muted)', marginTop: 4 }}>{km.toFixed(1)} km</div>
                    </div>

                    {/* Trucks count + status */}
                    <div style={{ display: 'flex', flexDirection: "column", alignItems: "flex-end" }}>
                      <div style={{ color: 'var(--cy-muted)', marginBottom: 6 }}>{o.orderStatus}</div>
                      <div style={{ color: '#fff', fontWeight: 600 }}>
                        <i className="pi pi-truck mx-2" style={{ color: 'var(--cy-accent)' }} />{o.trucksCount}
                      </div>
                    </div>
                  </div>
                </Card>
              );
            })}
          </div>
        )}


        {/* Assigned Orders view grouped by factory */}
        {!loading && !error && viewMode === 'grid' && showAssigned && (() => {
          const groups = orders.reduce((acc, o) => {
            const key = o.factoryId;
            if (!acc[key]) acc[key] = { factoryName: o.factoryName, orders: [] };
            acc[key].orders.push(o);
            return acc;
          }, {});

          return Object.entries(groups).map(([factoryId, group]) => (
            <div key={factoryId} style={{ display: 'grid', gap: 10 }}>
              {/* Factory header */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <i className="pi pi-map-marker" style={{ color: 'var(--cy-accent)' }} />
                <span style={{ background: 'rgba(59,130,246,0.15)', border: '1px solid rgba(59,130,246,0.35)', color: '#93c5fd', padding: '4px 10px', borderRadius: 8, fontWeight: 700, }}>{group.factoryName}</span>
                <span style={{ color: 'var(--cy-muted)', border: '1px solid rgba(255,255,255,0.08)', padding: '2px 8px', borderRadius: 8, }}>{group.orders.length} {group.orders.length > 1 ? "orders" : "order"}</span>
              </div>

              {/* Orders under factory */}
              {group.orders.map((o) => {
                const km = haversineKm(o.pickupLocation, o.deliveryLocation);
                return (
                  <Card key={o.orderId} className="cyber-card" style={{ overflow: "hidden" }}>
                    <div style={{ display: "grid", gap: 12 }}>
                      {/* Order row header */}
                      <div style={{ display: "grid", gridTemplateColumns: "1fr auto", alignItems: "center", }}>
                        <div className="d-flex justify-content-between">
                          <div>
                            <div style={{ fontWeight: 700, color: "#fff" }}>Order </div>
                            <div style={{ fontWeight: 700, color: "#fff" }}>#{o.orderNumber}</div>
                          </div>
                          <div style={{ display: "flex", alignItems: "center", fontWeight: 700, color: "var(--cy-muted)", marginTop: 4, }}>
                            <i className="pi pi-map-marker" style={{ fontSize: 24 }}></i>
                            <div className="d-flex flex-column align-items-start mx-2">
                              <span>{o.customerName}</span>
                              <span style={{ color: "var(--cy-muted)" }}>{Number(km).toFixed(2)} km</span>
                            </div>
                          </div>
                        </div>
                        <i className={`pi ${expanded[o.orderId] ? "pi-chevron-up" : "pi-chevron-down"}`} style={{ fontSize: 20, cursor: "pointer", color: "#fff", zIndex: 10 }} onClick={() => setExpanded((prev) => ({ ...prev, [o.orderId]: !prev[o.orderId] }))}></i>
                      </div>

                      {/* Expandable content */}
                      {expanded[o.orderId] && (
                        <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                          {o.assignments?.map((a) => (
                            <div key={a.assignmentId} style={{ gap: 8, background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.06)", padding: "6px 10px", borderRadius: 10, cursor: "pointer", zIndex: 1000 }}
                              onClick={() => {
                                const payload = {
                                  orderId: o.orderId,
                                  orderNumber: o.orderNumber,
                                  customerName: o.customerName,
                                  factoryId: o.factoryId,
                                  factoryName: o.factoryName,
                                  pickupLocation: o.pickupLocation,
                                  deliveryLocation: o.deliveryLocation,
                                  distanceKm: Number(haversineKm(o.pickupLocation, o.deliveryLocation)).toFixed(2),
                                  truck: {
                                    number: a.truckNumber,
                                    driverName: a.driverName,
                                  },
                                  status: a.status,
                                };
                                console.log("payload", payload);
                                navigate('/order-details', { state: payload });
                              }}
                            >
                              <div className="d-flex justify-content-between" style={{ gap: 20 }}>
                                <div>
                                  <i className="pi pi-truck" style={{ color: "var(--cy-accent)" }} />
                                  <span style={{ color: "#fff", fontWeight: 200 }}>{a.truckNumber}</span>
                                </div>
                                <span style={{
                                  background: a.status === "Delivered" ? "rgba(52,211,153,0.15)" : a.status === "Scheduled" ? "rgba(59,130,246,0.15)" : "rgba(234,179,8,0.15)",
                                  border: a.status === "Delivered" ? "1px solid rgba(52,211,153,0.35)" : a.status === "Scheduled" ? "1px solid rgba(59,130,246,0.35)" : "1px solid rgba(234,179,8,0.35)",
                                  color: a.status === "Delivered" ? "#34d399" : a.status === "Scheduled" ? "#60a5fa" : "#eab308",
                                  padding: "2px 8px", borderRadius: 8, fontSize: 12,
                                }}>{a.status}
                                </span>
                              </div>
                              <div className="d-flex justify-content-between">
                                <span style={{ color: "var(--cy-muted)" }}>{a.driverName}</span>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </Card>
                );
              })}
            </div>
          ));
        })()}
      </div>
    </div>
  );
}





// <Card key={o.orderId} className="cyber-card" style={{ overflow: 'hidden' }}>
//   <div style={{ display: 'grid', gap: 12 }}>
//     {/* Order row header */}
//     <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', alignItems: 'center' }}>
//       <div className='d-flex justify-content-between'>
//         <div style={{ fontWeight: 700, color: '#fff' }}>{o.orderNumber}</div>
//         <div style={{display:"flex",alignItems:"center", fontWeight: 700, color: '#fff', color: 'var(--cy-muted)', marginTop: 4 }}>
//           <i className="pi pi-map-marker" style={{ fontSize: 24 }}></i>
//           <div className='d-flex flex-column align-items-start mx-2'>
//           <span>{o.customerName}</span>
//           <span style={{ color: 'var(--cy-muted)' }}>{Number(km).toFixed(2)} km</span>
//           </div>
//         </div>
//       </div>
//     </div>

//     {/* Truck assignments row */}
//     <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
//       {o.assignments?.map(a => (
//         <div key={a.assignmentId} style={{ gap: 8, background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)', padding: '6px 10px', borderRadius: 10, }}>
//           <div className='d-flex justify-content-between ' style={{ gap: 20 }}>
//             <div >
//               <i className="pi pi-truck" style={{ color: 'var(--cy-accent)' }} />
//               <span style={{ color: '#fff', fontWeight: 600, }}>{a.truckNumber}</span>
//             </div>
//             <span style={{
//               background: a.status === 'Delivered' ? 'rgba(52,211,153,0.15)' : a.status === 'Scheduled' ? 'rgba(59,130,246,0.15)' : 'rgba(234,179,8,0.15)', border: a.status === 'Delivered' ? '1px solid rgba(52,211,153,0.35)' : a.status === 'Scheduled' ? '1px solid rgba(59,130,246,0.35)' : '1px solid rgba(234,179,8,0.35)', color: a.status === 'Delivered' ? '#34d399' : a.status === 'Scheduled' ? '#60a5fa' : '#eab308',
//               padding: '2px 8px', borderRadius: 8, fontSize: 12,
//             }}>{a.status}
//             </span>
//           </div>
//           <div className='d-flex justify-content-between'>
//             <span style={{ color: 'var(--cy-muted)' }}>{a.driverName}</span>
//           </div>
//         </div>
//       ))}
//     </div>
//   </div>
// </Card>